import cx from 'classnames';
import React from 'react';
import { Image } from '../image';
import { DefaultAppLogo, } from './default-app-logo';
/**
 * Single entry point for rendering the app logo.
 *
 * - Custom uploaded logo (`hasCustomLogo` + `customLogoUrl`) -> <img>,
 *   rendered as-is (tenant branding is never recolored).
 * - Otherwise -> the default ThoughtSpot mark as inline SVG, themed via
 *   `--ts-app-logo-color` (adapts to light/dark when radiant is enabled,
 *   white fallback for legacy).
 *
 * Presentational only: callers pass the custom-logo data as props. This keeps
 * the component free of any dependency on customStylingService / app context.
 */
export const AppLogo = ({ variant = 'square', customLogoUrl, hasCustomLogo = false, fallbackSrc, className, customLogoClassName, alt = '', }) => {
    if (hasCustomLogo && customLogoUrl) {
        return (React.createElement(Image, { className: cx(className, customLogoClassName), src: customLogoUrl, fallbackSrc: fallbackSrc, alt: alt }));
    }
    return React.createElement(DefaultAppLogo, { variant: variant, className: className });
};
//# sourceMappingURL=app-logo.js.map